export default __webpack_public_path__ + "static/customer-support.url-335041dfc748b106a60e61c7f9127b6f.svg";